// Explicit return type is load-bearing here, not redundant: `Array.isArray` narrows
// the true branch to `any[]`, so without the annotation the inferred return type
// widens to `any[]` instead of `unknown[]`.
export function toArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [value];
}

export function isPresent(value: unknown) {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return value !== undefined && value !== null && value !== '';
}

// Generated API clients often type a query param as its parsed (object) shape —
// matching what the OpenAPI spec documents — while the wire format is still a single
// JSON-encoded query string (HTTP query strings can't carry nested arrays/objects
// natively). This cast documents that gap rather than hiding it: `T` in, `T` out,
// only the runtime value is actually a JSON string.
export function toJsonQueryParam<T>(value: T) {
  return JSON.stringify(value) as unknown as T;
}
